/**
 * Process a string by replacing any spacing character by non-breaking space.
 * @param content - String to process
 */
export function avoidOrphanPunct(content: string): string {
  if (!content) return '';
  return content.trim().replace(/\s+(:|;|\?|!|»)/g, '&nbsp;$1');
}
